const OnboardingRoutes = [
  {
    path: "/onboarding",
    name: "Onboarding",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "OnboardingModule" */ "./pages/OnboardingPage.vue"
      ),
  },
  {
    path: "/onboarding/steps",
    name: "OnboardingSteps",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "OnboardingModule" */ "./pages/OnboardingStepsLayout.vue"
    ),
    children: [
      {
        path: "collection",
        name: "OnboardingAddCollection",
        component: () =>
          import(
            /* webpackChunkName: "OnboardingModule" */ "./components/Steps/AddCollection.vue"
        ),
      },
      {
        path: "profile",
        name: "OnboardingUpdateProfile",
        component: () =>
          import(
            /* webpackChunkName: "OnboardingModule" */ "./components/Steps/UpdateProfile.vue"
        ),
      },
      {
        path: "team",
        name: "OnboardingInviteTeam",
        component: () =>
          import(
            /* webpackChunkName: "OnboardingModule" */ "./components/Steps/InviteTeam.vue"
        ),
      }
    ]
  },
];

export default OnboardingRoutes;
